export interface CsvDownloadError {
  rowNumber: number;
  errorCode: string;
  errorMessage: string;
}

/**
 * Reads the original CSV file, filters lines that correspond to import errors,
 * appends "error_code" and "error_message" columns, and triggers a browser download.
 */
export function downloadCsvErrors(file: File, errors: CsvDownloadError[]): void {
  if (errors.length === 0) return;
  const reader = new FileReader();
  reader.onload = (e) => {
    const text = (e.target?.result as string) ?? '';
    const lines = text.split('\n').map(l => l.replace(/\r$/, ''));
    const headerLine = lines[0] ?? '';
    const csvEscape = (val: string) => `"${val.replace(/"/g, '""')}"`;
    const errorLines = errors.map(err => {
      const originalLine = lines[err.rowNumber - 1] ?? '';
      return `${originalLine},${csvEscape(err.errorCode)},${csvEscape(err.errorMessage)}`;
    });
    const csvContent = [`${headerLine},"error_code","error_message"`, ...errorLines].join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `errors_${file.name}`;
    a.click();
    URL.revokeObjectURL(url);
  };
  reader.readAsText(file);
}
